import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 1,
  class: "fst-italic"
}

import {computed, ref, watch, onMounted} from "vue";
import {BTableColumn, BTableOptions} from "./BTable/BTable.types";
import {BFilter, BFilterableField} from "./BFilterEditor/BFilterEditor.types";
import BGrid from "./BGrid/BGrid.vue";
import { useDcraStore } from "@/stores/dcraStore";
import { Submission } from "./DcraEditor/schema";


export default /*@__PURE__*/_defineComponent({
  __name: 'DcraSubmissions',
  setup(__props: any) {

const props = __props;

const dcraStore = useDcraStore();
var numberOfReturnedItems = ref(0);

//table settings and column info
var tableOptions = ref({
    totalItemCount: 0,
    itemsPerPage: 25,
    page: 1,
    sortBy: [
        {
            key: "lastUpdateDate",
            isDescending: true,
        },
    ],
    pagingMode: "noTotal",
} as BTableOptions);

const columns = computed(() => {
    let data: BTableColumn[] = [];

    data.push(
        {key: "quarter", text: "Quarter", sortable: false, value: (item) => item.quarter},
        {key: "lastUpdateDate", text: "Last Update Date", sortable: false, value: (item) => item.lastUpdateDate},
        {key: "numberOfDeaths", text: "Number Of Deaths", sortable: false, value: (item) => item.numberOfDeaths},
        {key: "fileName", text: "File Name", sortable: false, value: (item) => item.filename}
    );

    return data;
});

var items = ref([] as Submission[]);
function getSubmissionItems() {
    dcraStore
        .getSubmissionItems(tableOptions.value)
        .then((response) => { 
             
            if (tableOptions.value.pagingMode == "noTotal" && response?.data?.data?.length > 0) {
                items.value = response.data.data.slice(0, tableOptions.value.itemsPerPage);
            } else {
                items.value = response.data.data;
            }                     

            numberOfReturnedItems.value = response.data.data.length;
            
            tableOptions.value.totalItemCount = response.data.total;
        });
}

//LifeCycle Hooks
onMounted(()=> {
    getSubmissionItems();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BGrid, {
      caption: "submission list",
      tableOptions: _unref(tableOptions),
      items: _unref(items),
      columns: columns.value,
      "show-filter": false,
      "show-paging": true,
      "current-item-count": _unref(numberOfReturnedItems),
      onOptionChange: getSubmissionItems
    }, {
      "cell.fileName": _withCtx(({item, column}) => [
        (item.numberOfDeaths > 0)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: `FileDownload.ashx?file=${item.id}&type=0&source=dcra`,
              class: "btn btn-link"
            }, _toDisplayString(item.fileName), 9, _hoisted_2))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, "No File Available"))
      ]),
      _: 1
    }, 8, ["tableOptions", "items", "columns", "current-item-count"])
  ]))
}
}

})